import CreateAndEditUserForm from "../../../components/views/users/user-form";

function CreateAndEditUserPage() {
  return CreateAndEditUserForm();
}
export default CreateAndEditUserPage;
